export const isValidAmount = (value) => {
  value = Number(value.replace(/,/g, ''));
  const regex = /^\d{1,3}(,?\d{3})*(\.\d+)?$/;
  return regex.test(value);
};
